module.exports = __webpack_public_path__ + "static/media/icomoon.cee6e7de.eot";